import { CountryType } from "./countries";

export const extractPhoneNumberDetails = (
    fullPhoneNumber: string,
    countries: CountryType[]
) => {
    for (const country of countries) {
        if (fullPhoneNumber.startsWith(`+${country.phone}`)) {
            const phoneNumber = fullPhoneNumber.replace(`+${country.phone}`, "").trim();
            return { countryCode: country.code, phoneNumber };
        }
        if (fullPhoneNumber.startsWith(`00${country.phone}`)) {
            const phoneNumber = fullPhoneNumber.replace(`00${country.phone}`, "").trim();
            return { countryCode: country.code, phoneNumber };
        }
    }
    return { countryCode: "", phoneNumber: fullPhoneNumber };
};
